import $ from "jquery";

const filterShop = () => {
    const target = "#button-filter-btn";
    const $target = $(target);

    const init = () => {
        $(document).ready(function () {
        if ($target.length) {
            exec();
        }
        });
    };

    const exec = () => {
        const el = {
            filterShop: '.wapp-shop-filter__mobile',
            filterShopOverlay: '#filter-close'
        }

        $target.on('click', function (e) {
            e.preventDefault();

            $(el.filterShop).addClass('active');
            // $(this).parent().addClass('active');
            // $(".filter-btn-wrapper").addClass('active');
        });

        $(el.filterShopOverlay).on('click', function () {
            $(el.filterShop).removeClass('active');
        })

        // $(el.filterShop).on('click', function() {
        //     $(this).removeClass('active');
        // });
    };

    init();
};

try {
    filterShop();
} catch (error) {
    throw Error(error);
}
